<template>
  <div class="menubuilder__tselector">
    <h3>Coffee</h3>
    <p class="menubuilder__info">Add your pricing into the relevant boxes</p>
    <ul>
      <li>
        <span class="menubuilder__ttitle t-center hidden-mobile menubuilder__ttitle--coffee"></span>
        <span type="text" class="menubuilder__tprice t-center h5" v-if="hideOneSize.value !== true">One Size</span>
        <span type="text" class="menubuilder__tprice t-center h5">S</span>
        <span type="text" class="menubuilder__tprice t-center h5">M</span>
        <span type="text" class="menubuilder__tprice t-center h5">L</span>
      </li>
      <li v-for="(coffee, index) in coffees" :key="index">
        <!-- <span class="plus" @click="remove(coffee)"><span>-</span></span> -->
        <div class="menubuilder__ttitle menubuilder__ttitle--coffee" v-html="coffee.name" />
        <input type="text" class="menubuilder__tprice" v-model="coffee.oneSize" v-if="hideOneSize.value !== true" />
        <input type="text" class="menubuilder__tprice" v-model="coffee.s" />
        <input type="text" class="menubuilder__tprice" v-model="coffee.m" />
        <input type="text" class="menubuilder__tprice" v-model="coffee.l" />
      </li>
    </ul>
    <div class="menubuilder__add" v-if="false" @click="addNewCoffee">
      <span class="plus"><span>+</span></span>
      <span>Add a coffee (max 12)</span>
    </div>
  </div>
</template>


<script>
  export default {

    data: function () {
      return {
        hideOneSize: this.$store.state.hideOneSizeColumn,
        coffees: this.$store.state.customCoffees
      };
    },
    computed: {
    },
    props: [],
    methods: {
      addNewCoffee() {
        if(this.coffees.length < 12) {
          this.$store.addCustomCoffee('New Coffee', '2.60', '','','')
        }
      },
      remove(coffee){
        this.$store.removeCustomCoffee(coffee)
      }
    },
    computed: {
    },
    async mounted() {
    }
  }

</script>


<style lang="sass">
@import "../../../../styles/partials/variables"

#menubuilder
  .menubuilder
    &__ttitle--coffee
      flex: 0 1 50%

</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/components/MenuBuilder/CustomCoffeeSelector.vue